import { useSuspenseQuery } from '@tanstack/react-query'

import { GetProfissoesService } from '@/http/get-profissoes.service'
import { profissaoClienteKeys } from '@/utils/cliente-query-keys'

const SEIS_HORAS = 1000 * 60 * 60 * 6

export const useSuspenseProfissoes = () => {
  return useSuspenseQuery({
    queryKey: profissaoClienteKeys.lista(),
    queryFn: async () => new GetProfissoesService().execute().then((res) => res.data),
    staleTime: SEIS_HORAS,
  })
}
